import React from 'react';

import classNames from 'classnames';

class CardBody extends React.Component {
  render() {
    const { children } = this.props;
    return <div className={classNames('c-card__body')}>{children}</div>;
  }
}

export default CardBody;
